import { Controller } from 'stimulus';

class PrintController extends Controller {
  printPage() {
    window.print();

    return;
  }
}

export default PrintController;
